import BlogShow from './BlogShow'

export default BlogShow
